<template>
    <div>
        <div v-if="loading" class="brand-container">
            <p class="mt-3">Loading...</p>
        </div>

        <div v-else-if="error">
            <div class="error text-center">
                <div class="error-image">
                    <img src="/img/icons/error.svg" alt="" />
                </div>
                <div class="error-title">
                    Упс! Что-то пошло не так.
                </div>
                <div class="error-button">
                    <button type="button" class="cabinet-btn" @click="getBrand">
                        Попробовать еще раз
                    </button>
                </div>
            </div>
        </div>

        <template v-else>
            <div class="brand-main">
                <div class="brand-container">
                    <div class="brand-main__block">
                        <div class="brand-main__image">
                            <picture>
                                <source
                                    media="(max-width: 768px)"
                                    :srcset="brand.banner_mobile"
                                />
                                <img :src="brand.banner_desktop" alt="banner" />
                            </picture>
                        </div>
                        <div class="brand-main__info">
                            <div class="brand-main__logo">
                                <img :src="brand.logo" alt="" />
                            </div>
                            <h1 class="brand-main__title">
                                {{ brand.name }}
                            </h1>
                            <div class="brand-main__text" v-html="brand.description_short"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="carouselsFirst" class="brand-section">
                <div class="brand-container">
                    <div class="brand-page">
                        <h2 class="brand-page__title">
                            {{ carouselsFirst.name }}
                        </h2>
                        <div class="brand-page__swiper">
                            <div
                                :class="`js-products-prev-${carouselsFirst.id}`"
                                class="swiper__button swiper__button-prev"
                            ></div>
                            <div
                                :class="`js-products-next-${carouselsFirst.id}`"
                                class="swiper__button swiper__button-next"
                            ></div>
                            <div
                                :class="`swiper-products-${carouselsFirst.id}`"
                                class="swiper"
                            >
                                <div class="swiper-wrapper">
                                    <div
                                        v-for="item in carouselsFirst.items"
                                        :key="item.ItemID"
                                        class="swiper-slide"
                                    >
                                        <ProductItem :product="item" :isSubdomainBrand="true" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="categories && categories.length" class="brand-section">
                <div class="brand-container">
                    <div class="brand-page">
                        <div class="categories">
                            <div
                                v-for="item in categories"
                                :key="item.id"
                                class="categories__item"
                            >
                                <router-link :to="`/category/${item.url}`">
                                    <div class="categories__item-title">
                                        {{ item.name }}
                                        <span class="arrow"></span>
                                    </div>
                                    <div class="categories__item-image">
                                        <img :src="item.image_url" alt="" />
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <template v-if="carouselsOther">
                <div
                    v-for="section in carouselsOther"
                    :key="section.id"
                    class="brand-section"
                >
                    <div class="brand-container">
                        <div class="brand-page">
                            <h2 class="brand-page__title">
                                {{ section.name }}
                            </h2>
                            <div class="brand-page__swiper">
                                <div
                                    :class="`js-products-prev-${section.id}`"
                                    class="swiper__button swiper__button-prev"
                                ></div>
                                <div
                                    :class="`js-products-next-${section.id}`"
                                    class="swiper__button swiper__button-next"
                                ></div>
                                <div
                                    :class="`swiper-products-${section.id}`"
                                    class="swiper"
                                >
                                    <div class="swiper-wrapper">
                                        <div
                                            v-for="item in section.items"
                                            :key="item.ItemID"
                                            class="swiper-slide"
                                        >
                                            <ProductItem :product="item" :isSubdomainBrand="true" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <div v-if="collections && collections.length" class="brand-section">
                <div class="brand-container">
                    <div class="brand-page">
                        <h2 class="brand-page__title">Коллекции</h2>
                        <div class="collection__swiper">
                            <div class="swiper__buttons">
                                <div
                                    class="swiper__button swiper__button-prev js-collection-prev"
                                ></div>
                                <div
                                    class="swiper__button swiper__button-next js-collection-next"
                                ></div>
                            </div>
                            <div class="swiper swiper-collection">
                                <div class="swiper-wrapper">
                                    <div
                                        v-for="item in collections"
                                        :key="item.collection_id"
                                        class="swiper-slide"
                                    >
                                        <div class="collection__item">
                                            <router-link :to="{ name: 'SubdomainBrandProducts', params: { filterBy: { 'collections': item.collection_id } } }">
                                                <div
                                                    v-if="item.image"
                                                    class="collection__item-image"
                                                >
                                                    <img
                                                        :src="item.image.url"
                                                        alt=""
                                                    />
                                                </div>
                                                <div
                                                    class="collection__item-title"
                                                >
                                                    {{ item.name }}
                                                </div>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="brand-section">
                <div class="brand-container">
                    <h2 class="brand-page__title">О бренде</h2>
                    <div class="about">
                        <div class="about__image">
                            <img :src="brand.image" alt="banner" />
                        </div>
                        <div class="about__text" v-html="brand.description"></div>
                        <div class="brand-page__button">
                            <router-link to="/products" class="button"
                                >Все изделия бренда</router-link
                            >
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'

import ProductItem from '@/components/Public/Brand/Products/ProductItem'

import settings from '@/settings'

export default {
    name: 'SubdomainBrandHome',

    components: {
        ProductItem
    },

    data() {
        return {
            loading: true,
            error: false,
            swiperCollection: null
        }
    },

    computed: {
        ...mapGetters('subdomainBrand', {
            brand: 'item',
            carousels: 'carousels',
            collections: 'collections'
        }),
        ...mapGetters('subdomainBrand/categories', {
            categories: 'list'
        }),
        carouselsFirst() {
            return this.carousels &&
                this.carousels.length &&
                this.carousels[0].items.length
                ? this.carousels[0]
                : null
        },
        carouselsOther() {
            return this.carousels && this.carousels.length > 1
                ? this.carousels.slice(1).filter(el => el.items.length)
                : null
        }
    },

    async created() {
        await this.getBrand()

        document.title = this.brand.name
        document.getElementsByTagName('meta')["description"].content = this.brand.description_short
    },

    methods: {
        ...mapActions('subdomainBrand', [
            'getItem',
            'getCarousels',
            'getCollections'
        ]),
        ...mapActions('subdomainBrand/categories', {
            getCategories: 'getList'
        }),
        async getBrand() {
            try {
                this.loading = true
                this.error = false
                this.$Progress.start()

                await this.getItem(settings.BRAND_ID).finally(() => {
                    this.loading = false
                })

                await this.getBlocks()
            } catch (e) {
                this.error = true
            } finally {
                this.loading = false
                this.$Progress.finish()
            }
        },
        getBlocks() {
            return Promise.allSettled([
                this.getCarousels(settings.BRAND_ID).then(() => {
                    const swiperOptions = {
                        slidesPerView: 4,
                        spaceBetween: 32,
                        direction: 'horizontal',

                        breakpoints: {
                            1023: {
                                slidesPerView: 4.56,
                                spaceBetween: 24
                            },
                            768: {
                                slidesPerView: 3.42,
                                spaceBetween: 24
                            },
                            767: {
                                slidesPerView: 3.54,
                                spaceBetween: 16
                            },
                            575: {
                                slidesPerView: 1.48,
                                spaceBetween: 16
                            }
                        }
                    }

                    this.carousels.forEach(el => {
                        const swiperProducts = new Swiper(
                            `.swiper-products-${el.id}`,
                            {
                                ...swiperOptions,
                                navigation: {
                                    nextEl: `.js-products-next-${el.id}`,
                                    prevEl: `.js-products-prev-${el.id}`
                                }
                            }
                        )
                    })
                }),
                this.getCategories(settings.BRAND_ID),
                this.getCollections(settings.BRAND_ID).then(() => {
                    this.swiperCollection = new Swiper('.swiper-collection', {
                        slidesPerView: 3,
                        spaceBetween: 32,
                        direction: 'horizontal',

                        navigation: {
                            nextEl: '.js-collection-next',
                            prevEl: '.js-collection-prev'
                        },

                        breakpoints: {
                            1023: {
                                slidesPerView: 3,
                                spaceBetween: 24
                            },
                            767: {
                                slidesPerView: 3.59,
                                spaceBetween: 16
                            },
                            575: {
                                slidesPerView: 1.48,
                                spaceBetween: 16
                            }
                        }
                    })
                })
            ])
        }
    }
}
</script>

<style>
.categories__item-image {
    background-color: gray;
}
</style>
